<template>
  <div class="area-form-cell">
    <van-field
        v-model="value"
        :name="name+'Name'"
        :label="label"
        :label-width="labelWidth || 140"
        :placeholder="placeholder"
        @click="onSelect"
        :required="true"
        :rules="[{ required: true, message: '请填写区域' }]"
        readonly
        :clickable="editor"
    >
    </van-field>
    <van-popup v-model="showPicker" position="bottom">
      <van-area
          :area-list="areaList"
          :value="index"
          @confirm="onConfirm"
          @change="onChange"
          @cancel="showPicker = false"
      />
    </van-popup>
    <van-field v-model="index" :name="name" v-show="false"/>
  </div>
</template>

<script>

export default {
  name: "areaFormCell",
  props: ['label', 'name', 'initIndex', 'initValue', 'columns','placeholder', 'areaList', 'labelWidth', 'editor'],
  data() {
    return {
      index: this.initIndex,
      value: this.initValue,
      showPicker: false,
    }
  },
  watch: {
    initValue(newValue, oldValue) {
      console.log('area initValue => area ', newValue, oldValue)
      this.value = newValue
    },
    initIndex(newValue, oldValue) {
      console.log('area initIndex => area ', newValue, oldValue)
      this.index = newValue
    }
  },
  methods: {
    onChange(event, value, index) {
      console.log('area => value ', value)
      console.log('area => index ', index)
    },
    onConfirm(value, index) {
      console.log('onConfirm => value ', value, index)
      this.value = value.map(value => { return value.name}).join(',')
      this.index = value.pop().code
      this.$emit('change',this.index)
      this.$emit('changeValue',this.value)
      this.showPicker = false
    },
    onSelect(value) {
      if (this.editor === false) {
        return
      }
      this.showPicker = true
      // console.log('onSelect => onSelect ', value)
    }
  }
}
</script>

<style lang="less">
.area-form-cell {
  //.van-field--disabled .van-field__label {
  //  color: #646566;
  //}
  .van-picker__confirm {
    color: #3D8AFF;
  }
  .van-picker__cancel {
    color: #3D8AFF;
  }
  .van-field__label {
    font-size: 13px;
    font-weight: 400;
    color: #3F403F;
  }
  .van-cell {
    padding: 10px 16px 10px 22px !important;
  }
  .van-cell--required::before {
    left: 14px !important;
  }
}
</style>

<style scoped lang="less">
.select-form-cell {

}
</style>



// WEBPACK FOOTER //
// src/modules/marketCenter/formCell/areaFormCell.vue